import React, { useState } from "react";
import { read } from "Helpers/LocalStorage";
import UserService from "Services/http/endpoints/user/UserService";
import StatusHandler from "Helpers/StatusHandler";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import showNotify from "Helpers/Notify";
import {ReactSVG} from "react-svg";
import DeleteUser from "Assets/svg/icon/deleteUser.svg";
import { useTranslation } from 'react-i18next';

function DeleteUserInfo({ row }) {
  const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeyUserDelete: row.Key,
      };
      const response = await UserService.deleteUserInfo(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        onShowAlert();
        showNotify({
          text: t('successfullyUserInformationDeleted'),
          customClass: "success",
        });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="deleteInfo" />}
        icon={<ReactSVG src={DeleteUser}/>}
        className="danger-fill"
        onClick={onShowAlert}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onFinish}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={t('sureForDeleteUserInfoWP').replace('@P1', row.DisplayName)}
        loading={loading}
      />
    </>
  );
}
export default DeleteUserInfo;
